// extracted by mini-css-extract-plugin
export default {"color-picker":"ColorPicker_color-picker__MkxRU","color-picker__input":"ColorPicker_color-picker__input__3upx0"};